import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../components/utils/api";
import Cookies from "js-cookie";

// Async thunk for login
export const loginUser = createAsyncThunk(
  "user/login",
  async (credentials, { rejectWithValue }) => {
    try {
      const endpoint = "users/login";
      const res = await api.post(endpoint, credentials);

      // Save token to Cookies with 1 day timeout
      Cookies.set("token", res.data.token, { expires: 1 });

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Login failed");
    }
  },
);

// Async thunk for register
export const registerUser = createAsyncThunk(
  "user/register",
  async (credentials, { rejectWithValue }) => {
    try {
      const endpoint = "users/register";
      const res = await api.post(endpoint, credentials);

      // Save token to Cookies with 1 day timeout
      Cookies.set("token", res.data.token, { expires: 1 });

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Register failed");
    }
  },
);

// Async thunk for logout
export const logoutUser = createAsyncThunk(
  "user/logout",
  async (_, { rejectWithValue }) => {
    try {
      Cookies.remove("token");
      return null;
    } catch (err) {
      return rejectWithValue("Logout Failed");
    }
  },
);

// Async thunk to fetch current user
export const fetchCurrentUser = createAsyncThunk(
  "users/me",
  async (_, { rejectWithValue }) => {
    try {
      const endpoint = "users/me";
      const res = await api.get(endpoint);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch user",
      );
    }
  },
);

const initialState = {
  user: null,
  token: Cookies.get("token") || null,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Login
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Logout
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.error = null;
      })
      // Register
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.token = action.payload.token;
        state.error = null;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Current User
      .addCase(fetchCurrentUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.user;
        state.error = null;
      })
      .addCase(fetchCurrentUser.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { clearError, setUser } = userSlice.actions;

export default userSlice.reducer;
